export const storeProducts = [
  {
    id: 1,
    title: "Flair Sneakers",
    img: "img/product-1.jpeg",
    price: 29.99,
    company: "Sneakers",
    info: 
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Laceup Sneakers",
    img: "img/product-2.jpeg",
    price: 16.99,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Ledi Sneakers",
    img: "img/product-3.jpeg",
    price: 40,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Armold Sneakers",
    img: "img/product-4.jpeg",
    price: 23,
    company: "Thor",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Air Laceup Sneakers",
    img: "img/product-5.jpeg",
    price: 50,
    company: "Air laceup",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Lightup Sneakers",
    img: "img/product-6.jpeg",
    price: 60,
    company: "Light ",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.T",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Diamond Sneakers",
    img: "img/product-7.jpeg",
    price: 40,
    company: "Diamond",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Ashtop Sneakers",
    img: "img/product-8.jpeg",
    price: 74,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  }
  ,
  {
    id: 9,
    title: "Top Sneakers",
    img: "img/product-9.jpeg",
    price: 15,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  }
  ,
  {
    id: 10,
    title: "Lindle Sneakers",
    img: "img/product-10.jpeg",
    price: 25,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  }
  ,
  {
    id: 11,
    title: "Shell Sneakers",
    img: "img/product-11.jpeg",
    price: 12,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  }
  ,
  {
    id: 12,
    title: "Pinklace Sneakers",
    img: "img/product-12.jpeg",
    price: 32,
    company: "Sneakers",
    info:
      "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture..",
    inCart: false,
    count: 0,
    total: 0
  }
  
];

export const detailProduct = {
  id: 9,
  title: "Full  Sneakers",
  img: "img/product-2.jpeg",
  price: 16.99,
  company: "Full",
  info:
    "Fancy soles sneaker is the pitch classic that has forever redefined basketball shoes and sneaker culture. The suede details on synthetic leather in the upper material ensure the legendary style, which has put it at the forefront for decades on the street as well as in sports and culture.",
  inCart: false,
  count: 0,
  total: 0
};
